// Resolved at runtime by Wgpt::Ai::Agents::Bots::MainWorkflowAgent#create_prompt
export const MAIN_PROMPT_SYSTEM_PARAMETERS = [
  'AI_EMPLOYEE_NAME',
  'STAGES',
  'STAGES_COUNT',
  'STAGE_NUMBER',
  'STAGE_NAME',
  'STAGE_DESCRIPTION',
  'RAG_CONTEXT',
  'CONTACT_NAME',
  'CONTACT_EMAIL',
  'CONTACT_PHONE',
];

// Mirrors Wgpt::Ai::Prompts::Template: `{NAME}` is substituted at runtime only
// when NAME exactly matches a provided parameter; `{{...}}` is an escaped literal.
const TOKEN_PATTERN = /\{\{[^{}]*\}\}|\{\s*([A-Za-z0-9_]+)\s*\}/g;

// Workflow parameter keys are upcased at runtime, so `{COMPANY_NAME}` resolves
// for a `company_name` parameter while `{company_name}` never does.
export const knownPromptParameters = workflowParameterKeys => [
  ...new Set([
    ...MAIN_PROMPT_SYSTEM_PARAMETERS,
    ...workflowParameterKeys.map(key => key.toUpperCase()).filter(Boolean),
  ]),
];

export const tokenizePrompt = (text, knownNames) => {
  const segments = [];
  let lastIndex = 0;

  [...text.matchAll(TOKEN_PATTERN)].forEach(({ 0: token, 1: name, index }) => {
    if (index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, index) });
    }
    if (name) {
      const valid = token === `{${name}}` && knownNames.includes(name);
      segments.push({ text: token, variable: true, valid });
    } else {
      segments.push({ text: token });
    }
    lastIndex = index + token.length;
  });

  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex) });
  }
  return segments;
};

export const invalidPromptVariables = (text, knownNames) => {
  const tokens = tokenizePrompt(text, knownNames)
    .filter(segment => segment.variable && !segment.valid)
    .map(segment => segment.text);
  return [...new Set(tokens)];
};
